import React from "react";
import Navbar from "./navBar";
import HomePage from "./homePage";
import Footer from "./footer";

function App() {
    return (
        <div>
            <Navbar></Navbar>
            <HomePage></HomePage>
            <Footer></Footer>
        </div>
    )
}

export default App;
